export function hasErrorProperties(error: unknown): error is Error {
    if (error == undefined) return false;
    if (typeof error !== 'object') return false;
    if (error instanceof Error) return true;
    if (!('name' in error) || typeof error.name !== 'string') return false;
    if (!('message' in error) || typeof error.message !== 'string') return false;

    return !('stack' in error) || error.stack == undefined || typeof error.stack === 'string';
}
